document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-scroll-target]").forEach((link) => {
    link.addEventListener("touchstart", (e) => { e.stopPropagation(); }, true);

    link.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollToReviews();
    }, true);
  });

  function scrollToReviews() {
    const heading = document.getElementById("reviews");
    if (!heading) return;

    const targetOffset = heading.getBoundingClientRect().top + document.body.scrollTop;
    document.body.scrollTo({ top: targetOffset, behavior: "smooth" });
    window.scrollTo({ top: targetOffset, behavior: "smooth" });
  }
});